module.exports = __webpack_public_path__ + "static/media/avatar-3.4b508f06.jpg";